/* eslint-disable */
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import ItineraryView from "./components/ItineraryView";
import AvantLeDepart from "./components/AvantLeDepart";
import Settings from "./components/Settings";
import TripCreationModal from "./components/TripCreationModal";
import NotFound from "./components/NotFound";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/trip/new" element={<TripCreationModal />} />
        <Route path="/trip/:tripId" element={<ItineraryView />} />
        <Route path="/trip/:tripId/avant-le-depart" element={<AvantLeDepart />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
